import { render, staticRenderFns } from "./AddFundHistory.vue?vue&type=template&id=6588e4ca&"
import script from "./AddFundHistory.vue?vue&type=script&lang=js&"
export * from "./AddFundHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports